module.exports = __webpack_public_path__ + "static/media/Projects.c94465a3.svg";